module.exports = __webpack_public_path__ + "img/kobe.4f1aeee6.jpg";